import NetlifyAuthenticationPage from './NetlifyAuthenticationPage';
import PKCEAuthenticationPage from './PKCEAuthenticationPage';

export const DecapCmsUiAuth = {
  NetlifyAuthenticationPage,
  PKCEAuthenticationPage,
};
export { NetlifyAuthenticationPage, PKCEAuthenticationPage };
